import React from "react";
import SubjectRegistry from "../components/SubjectRegistry";

export default function RiskClients() {
  return <SubjectRegistry kind="client" titleKey="k.clients" subKey="k.clients_sub" addKey={null} fields={[]} testid="clients" />;
}
